import Vue from 'vue'
import gitinfo from './git.js'
const release = gitinfo.abbreviated_commit;
import App from "./App.vue";
//test azure sync
import {
    store
} from "./Store"
import {
    AmplifyEventBus
} from './plugins/aws-amplify-vue';
Vue.prototype.$eventBus = AmplifyEventBus;
import moment from 'moment'
Vue.prototype.$moment = moment;
import {
    Dropdown,
    DropdownMenu,
    DropdownItem
} from 'element-ui'
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
import router from "./router";
import introJs from 'intro.js/intro.js';
import "./registerServiceWorker";
import selectable from 'vue-selectable';
//plugins
import VueApollo from "vue-apollo";
Vue.use(VueApollo);
 import ApolloClient from "apollo-client";
 import { HttpLink } from "apollo-link-http";
 import { InMemoryCache } from "apollo-cache-inmemory";
  Vue.config.productionTip = false;
 const getHeaders = () => {
  //const headers = {};
let headers = {
          "content-type": "application/json",
          //"x-hasura-admin-secret": "8XEE1cxsiTz15hH6WTDWnyFK8tRH4iyTGyvBKOL59DFZsMhtu5woVj01ZyMSic9P",
          "x-hasura-access-key": "bl8CMPtNYxUAyFwXVfQwHwKErCXKQLGFh9VIN7cmP8p2zVYEY8155VwxIyIVnk4N",
          "x-hasura-admin-secret": "pea6oahdFn5jakHPDS0KCKC8iAXd4kXP3vjTPKMUGcODbhWruWkzGDCqIo76dDmw",
          //"x-hasura-access-key": "",
        }
   //const token = window.localStorage.getItem('apollo-token');
   const token = store.getters.get('apollo-token');
   const user = store.getters.get('user');
   if (token) {
     headers.authorization = `Bearer ${token}`;
   }
   if ( user && user.username ) {
   headers["X-Hasura-User-ID"] = user.username;
   headers["X-Hasura-Role"] = 'readwrite'
   }
   return headers;
 };
 // Create an http link:
 const link = new HttpLink({
   //uri: 'https://asia.hasura.app/v1/graphql',
   uri: 'https://dtu-asiaalt-2021.hasura.app/v1/graphql',
   fetch,
   headers: getHeaders()
 });
 const client = new ApolloClient({
   link: link,
   cache: new InMemoryCache({
     addTypename: true
   })
 });
const apolloProvider = new VueApollo({
    defaultClient: client,
  })
import UIKit from './plugins/ui-kit';
import VueAwesomeSwiper from '@/components/swiper';
import '@/components/swiper/swiper.css';
Vue.use(VueAwesomeSwiper);
import flatpickr from "flatpickr"
Vue.use(flatpickr);
import Adal from 'vue-adal'
Vue.use(Adal, {
  config: {
    //tenant: '2ba346e0-63d8-43cc-a9f3-45685fbd87a6',
    //tenant: '36fc765b-b21f-4473-a2b1-c5d0e49baaba',
    //tenant: '36fc765b-b21f-4473-a2b1-c5d0e49baaba',
    tenant: '61694941-f649-4b38-b96f-0ccdfdc0fc56',
    //clientId: '3bac4780-7ac2-45e6-aaa6-bfe0cfb8c30e',
    //clientId: 'c5751cca-cc1d-444f-80d5-70df438a80ff',
    clientId: '6e0cdae3-9345-4b51-aa10-8d00a3512389',
    redirectUri: '',
    cacheLocation: 'localStorage'
  },
requireAuthOnInitialize: false,
  router: router
})
import VModal from 'vue-js-modal';
import VueForm from 'vue-form';
import {
    VueSpinners
} from '@saeris/vue-spinners'
//import apolloProvider from "@/appsync";
import Multiselect from 'vue-multiselect'
import {
    Switch,
    Progress,
    Drawer
} from 'element-ui'
import {
    VueContext
} from 'vue-context';
import LZString from 'lz-string'
import VTooltip from 'v-tooltip'
import SideBar from './components/SidebarPlugin';
Vue.use(SideBar)
import './assets/sass/dashboard.scss';
var juice = require('juice/client')
window.juice = juice
import GenoSpinner from './components/GenoSpinner.vue'
Vue.component('geno-spinner', GenoSpinner)
import GenoLogo from './svg/icon-glogo.svg';
Vue.component('geno-logo', GenoLogo)
Vue.component('multiselect', Multiselect)
Vue.component('vue-context', VueContext)
import vueCustomScrollbar from 'vue-custom-scrollbar'
import "vue-custom-scrollbar/dist/vueScrollbar.css"
import TextareaAutosize from 'vue-textarea-autosize'
import * as pbi from 'powerbi-client';
Vue.use(TextareaAutosize)
Vue.use(vueCustomScrollbar);
Vue.component('vue-custom-scrollbar', vueCustomScrollbar);
Vue.directive('selectable', selectable);
Vue.use(Progress)
Vue.use(UIKit)
Vue.use(Drawer);
Vue.use(Switch);
Vue.use(VueForm)
Vue.use(VTooltip, {
    autoHide: true,
    defaultHideOnTargetClick: true,
    defaultTrigger: 'hover',
    defaultDelay: {
        show: 300,
        hide: 100
    }
})
Vue.use(LZString)
Vue.use(VModal, {
    dialog: true,
    dynamic: true,
    injectModalsContainer: true
})

Vue.use(VueSpinners)
Vue.config.productionTip = false;
new Vue({
    store,
    router,
    apolloProvider,
    render: h => h(App),
    created() {
        if (sessionStorage.redirect) {
            const redirect = sessionStorage.redirect
            delete sessionStorage.redirect
            this.$router.push(redirect)
        }
    }
}).$mount("#app");

window.addEventListener("offline", function(e) {
    console.warn('Browser is offline');
    store.commit('change', {
        onLine: false
    });
});
window.addEventListener("online", function(e) {
    console.warn('Browser is online!');
    store.commit('change', {
        onLine: true
    });
});
